import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedInAuthGuard } from './RoutingAuth/LoggedInAuthGuard';
import { AuthGuardModule } from './auth.module';
import { EmployeeAuthGuard } from './RoutingAuth/EmployeeAuthGuard';
import { PersonRoleEnum } from './Models/OtherClasses';
import { PaidAuthGuard } from './RoutingAuth/PaidAuthGuard';
import { HREmployeeAuthGuard } from './RoutingAuth/HREmployeeAuthGuard';
import { LMSEmployeeAuthGuard } from './RoutingAuth/LMSEmployeeAuthGuard';

const routes: Routes = [
	{ path: '', redirectTo: 'ang/Dash', pathMatch: 'full' },
	{ path: 'ang', redirectTo: 'ang/Dash', pathMatch: 'full' },
	{
		path: 'ang/Dash', loadChildren: () => import('./Components/Dashboard/Dashboard.Module').then(m => m.DashboardModule),
		canLoad: [PaidAuthGuard]
	},
	{
		path: 'ang/Announcement', loadChildren: () => import('./Components/CompanyAnnouncement/CompanyAnnouncement.Module').then(m => m.CompanyAnnouncementModule),
		canLoad: [PaidAuthGuard]
	},
	{
		path: 'ang/AppHelpInfo', loadChildren: () => import('./Components/AppHelpInfo/AppHelpInfo.Module').then(m => m.AppHelpInfoModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/Calendar', loadChildren: () => import('./Components/Calendar/Calendar.Module').then(m => m.CalendarModule),
		canLoad: [PaidAuthGuard, HREmployeeAuthGuard]
	},
	{
		path: 'ang/Checklist', loadChildren: () => import('./Components/Checklist/Checklist.Module').then(m => m.ChecklistModule),
		canLoad: [PaidAuthGuard, HREmployeeAuthGuard]
	},
	{
		path: 'ang/Commendation', loadChildren: () => import('./Components/Commendation/Commendation.Module').then(m => m.CommendationModule),
		canLoad: [PaidAuthGuard, HREmployeeAuthGuard]
	},
	{
		path: 'ang/Company', loadChildren: () => import('./Components/Company/Company.Module').then(m => m.CompanyModule),
		canLoad: [LoggedInAuthGuard, EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.ADMIN]
		}
	},
	{
		path: 'ang/CompanyCourse', loadChildren: () => import('./Components/CompanyCourse/CompanyCourse.Module').then(m => m.CompanyCourseModule),
		canLoad: [PaidAuthGuard, LMSEmployeeAuthGuard ]
	},
	{
		path: 'ang/Course', loadChildren: () => import('./Components/Course/Course.Module').then(m => m.CourseModule),
		canLoad: [PaidAuthGuard, LMSEmployeeAuthGuard ]
	},
	{
		path: 'ang/CourseAssignment', loadChildren: () => import('./Components/CourseAssignment/CourseAssignment.Module').then(m => m.CourseAssignmentModule),
		canLoad: [PaidAuthGuard, LMSEmployeeAuthGuard ]
	},
	
	{
		path: 'ang/Department', loadChildren: () => import('./Components/Department/Department.Module').then(m => m.DepartmentModule),
		canLoad: [PaidAuthGuard, HREmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.ADMIN]
		}
	},
	{
		path: 'ang/DocumentAssignment', loadChildren: () => import('./Components/DocumentAssignment/DocumentAssignment.Module').then(m => m.DocumentAssignmentModule),
		canLoad: [PaidAuthGuard, HREmployeeAuthGuard]
	},
	{
		path: 'ang/DocumentHistory', loadChildren: () => import('./Components/DocumentHistory/DocumentHistory.Module').then(m => m.DocumentHistoryModule),
		canLoad: [PaidAuthGuard, HREmployeeAuthGuard]
	},
	{
		path: 'ang/Job', loadChildren: () => import('./Components/JobDesignation/JobDesignation.Module').then(m => m.JobDesignationModule),
		canLoad: [PaidAuthGuard, HREmployeeAuthGuard],
		canActivateChild: [PaidAuthGuard, HREmployeeAuthGuard],
	},
	{
		path: 'ang/LeaveRequest', loadChildren: () => import('./Components/LeaveRequest/LeaveRequest.Module').then(m => m.LeaveRequestModule),
		canLoad: [PaidAuthGuard, HREmployeeAuthGuard]
	},

	{
		path: 'ang/Office', loadChildren: () => import('./Components/Office/Office.Module').then(m => m.OfficeModule),
		canLoad: [PaidAuthGuard, HREmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.ADMIN]
		}
	},
	{
		path: 'ang/Reports', loadChildren: () => import('./Components/Reports/Reports.Module').then(m => m.ReportsModule),
		canLoad: [PaidAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/PTOTemplate', loadChildren: () => import('./Components/PTOTemplate/PTOTemplate.Module').then(m => m.PTOTemplateModule),
		canLoad: [PaidAuthGuard, HREmployeeAuthGuard]
	},
	{
		path: 'ang/PerformanceReview', loadChildren: () => import('./Components/PerformanceReview/PerformanceReview.Module').then(m => m.PerformanceReviewModule),
		canLoad: [PaidAuthGuard, HREmployeeAuthGuard]
	},
	{
		path: 'ang/Person', loadChildren: () => import('./Components/Person/Person.Module').then(m => m.PersonModule),
		canLoad: [PaidAuthGuard]
	},
	{
		path: 'ang/Payment', loadChildren: () => import('./Components/Payment/Payment.Module').then(m => m.PaymentModule),
		canLoad: [LoggedInAuthGuard]
	},
	{
		path: 'ang/Stats', loadChildren: () => import('./Components/Stats/Stats.Module').then(m => m.StatsModule),
		canLoad: [LoggedInAuthGuard]
	},
	{
		path: 'ang/TrackerDoc', loadChildren: () => import('./Components/TrackerDoc/TrackerDoc.Module').then(m => m.TrackerDocModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.ADMIN]
		}
	},
	{
		path: 'ang/TypeCalendarEvent', loadChildren: () => import('./Components/TypeCalendarEvent/TypeCalendarEvent.Module').then(m => m.TypeCalendarEventModule),
		canLoad: [EmployeeAuthGuard, LMSEmployeeAuthGuard ],
		data: {
			allowedRoles: [PersonRoleEnum.ADMIN]
		}
	},
	{
		path: 'ang/TypeCompanyDiscount', loadChildren: () => import('./Components/TypeCompanyDiscount/TypeCompanyDiscount.Module').then(m => m.TypeCompanyDiscountModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/TypeCourseCatagory', loadChildren: () => import('./Components/TypeCourseCatagory/TypeCourseCatagory.Module').then(m => m.TypeCourseCatagoryModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/TypeCourseTag', loadChildren: () => import('./Components/TypeCourseTag/TypeCourseTag.Module').then(m => m.TypeCourseTagModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/TypeSubscriptionCategory', loadChildren: () => import('./Components/TypeSubscriptionCategory/TypeSubscriptionCategory.Module').then(m => m.TypeSubscriptionCategoryModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
{
		path: 'ang/TypeTracker', loadChildren: () => import('./Components/TypeTracker/TypeTracker.Module').then(m => m.TypeTrackerModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/TypeCountry', loadChildren: () => import('./Components/TypeCountry/TypeCountry.Module').then(m => m.TypeCountryModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/TypeEmployment', loadChildren: () => import('./Components/TypeEmployment/TypeEmployment.Module').then(m => m.TypeEmploymentModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/TypeGender', loadChildren: () => import('./Components/TypeGender/TypeGender.Module').then(m => m.TypeGenderModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/TypeMaritalStatus', loadChildren: () => import('./Components/TypeMaritalStatus/TypeMaritalStatus.Module').then(m => m.TypeMaritalStatusModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/TypePaymentSubscription', loadChildren: () => import('./Components/TypePaymentSubscription/TypePaymentSubscription.Module').then(m => m.TypePaymentSubscriptionModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},

	{
		path: 'ang/TypePhone', loadChildren: () => import('./Components/TypePhone/TypePhone.Module').then(m => m.TypePhoneModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/TypeSalary', loadChildren: () => import('./Components/TypeSalary/TypeSalary.Module').then(m => m.TypeSalaryModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/TypeSalaryChange', loadChildren: () => import('./Components/TypeSalaryChange/TypeSalaryChange.Module').then(m => m.TypeSalaryChangeModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/TypeSourceOfHire', loadChildren: () => import('./Components/TypeSourceOfHire/TypeSourceOfHire.Module').then(m => m.TypeSourceOfHireModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/TypeTermination', loadChildren: () => import('./Components/TypeTermination/TypeTermination.Module').then(m => m.TypeTerminationModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	},
	{
		path: 'ang/Search', loadChildren: () => import('./Components/Search/Search.Module').then(m => m.SearchModule),
		canLoad: [EmployeeAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SUPERADMIN]
		}
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }), //https://stackoverflow.com/questions/48048299/angular-5-scroll-to-top-on-every-route-click/48048822
		AuthGuardModule.forRoot()
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
